import { render, staticRenderFns } from "./warning-details.vue?vue&type=template&id=3fe3962c"
import script from "./warning-details.vue?vue&type=script&lang=ts"
export * from "./warning-details.vue?vue&type=script&lang=ts"
import style0 from "./warning-details.vue?vue&type=style&index=0&id=3fe3962c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports